import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { useGetKimThreadFileChunk } from '@/api/queries/useGetKimThreadFileChunk';
import { KimThreadFileViewer } from '@/new/components/doc-viewer/kim-thread-file-viewer';
import { ChunkDrawerContentShell } from '@/new/components/reference-content/chunk-drawer-content-shell';
import { BoundingBoxWithId } from '@/types';

interface ThreadFileChunkDrawerContentProps {
  chunkId: string;
}

export function ThreadFileChunkDrawerContent({ chunkId }: ThreadFileChunkDrawerContentProps) {
  const { matterId, subsetId, threadId } = useParams();
  const { data: chunk, isLoading, error } = useGetKimThreadFileChunk(matterId, subsetId, threadId, chunkId);

  const highlight: BoundingBoxWithId | null = useMemo(
    () => (chunk ? { ...chunk.boundingBox, id: chunk.id } : null),
    [chunk],
  );

  return (
    <ChunkDrawerContentShell
      isLoading={isLoading}
      error={error}
      errorLabel="thread file chunk"
      viewer={chunk && highlight ? <KimThreadFileViewer fileUrl={chunk.file.url} highlight={highlight} /> : null}
      tab={{ id: chunk?.file.id ?? '', label: chunk?.file.name ?? '' }}
      sourceText={chunk?.content ?? ''}
    />
  );
}
